import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

export class DarethsHouseExterior extends Scene {
  async init() {
    this.image = require("@/images/Vincent_Dareths_House.png");
    this.title = "Dareth's House";
    this.description = "";
    this.audio = null;
  }

  get options(): any[] {
    return [
      new Choice("Approach Dareth's House ", async () => {
        if (this.state.storylines.infectedWithYogid) {
          this.description =
            "SONNY YANG: I'm not going back into that diseased hell hole.";
          this.audio = require("@/audio/Pandemic-180-Sonny-MP3.mp3");
        } else {
          await this.navigate(scenes.DarethsFence());
        }
      }),
      new Choice("Go Left", async () => {
        await this.navigate(scenes.HospitalExterior());
      }),
      new Choice("Go Right", async () => {
        await this.navigate(scenes.BankExterior());
      }),
    ];
  }
}

export default new DarethsHouseExterior();
